// Title: auto-sale.js
// Created by: Reid Williams
// Last Modified by: Reid Williams
// Last Modified: Oct 11, 2024
// Description: This script calculates and formats the sale price of a product based on the original price and sale percentage.
//              It updates the displayed price in the Recharge widget.

function formatMoney(cents, format = "") {
  // Convert cents to a string if necessary
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.themeVariables.settings.moneyFormat;

  function defaultTo(value, defaultValue) {
    // Ensure value is not null or NaN
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    // Set default values for formatting
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    // Convert to cents, round up, then format
    number = Math.ceil(number) / 100;
    number = number.toFixed(precision);

    let parts = number.split("."),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : "";

    return dollarsAmount + centsAmount;
  }

  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}

//----------------
//UPDATE SALE PRICE - CUSTOM PRICE
//----------------
function updateSalePrice() {
  // --- Get Sale Amount and Variant Price ---
  // const productMeta = document.getElementById('ProductMeta');
  // let saleAmount = parseInt(productMeta.getAttribute('data-sale-amount'), 10) || 0;

  // If saleAmount is 0, do not change prices
  if (saleAmount === 0) {
    //console.log("Sale amount is 0, prices will not be changed.");
    return; // Exit the function early
  }

  const variantPriceElement = document.getElementById('VariantPrice-Sale');
  const variantPriceText = variantPriceElement.getAttribute('data-variant-price');
  const variantPrice = parseFloat(variantPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  // Calculate the discount amount and updated price
  const discountAmount = (variantPrice * (saleAmount / 100));
  const updatedPrice = variantPrice - discountAmount; 
  const formattedUpdatedPrice = formatMoney(updatedPrice * 100); 

  const formattedOriginalPrice2 = formatMoney(variantPrice * 100).replace('.00', '');

  // Calculate the stacked discount as a percentage of the original price
  const discountStacked = (updatedPrice * (15 / 100));
  const updatedPriceSub = updatedPrice - discountStacked; // Subtract the discount from the original price
  const formattedUpdatedPriceSub = formatMoney(updatedPriceSub * 100);
  
  // Use MutationObserver to update prices in the Recharge widget
  const observer = new MutationObserver(function(mutations, observerInstance) {
    const rechargePriceElement = document.querySelector('.rc-radio__price');
    if (rechargePriceElement) {
      //rechargePriceElement.textContent = ' ' + formattedUpdatedPrice;

      rechargePriceElement.innerHTML = ` ${variantPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: #808181;">${formattedOriginalPrice2}</span>
      <span style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; margin-left: 8px;border: 1px solid rgb(var(--border-color));">

            ${saleAmount}% OFF
          </span>`;
     /*
      rechargePriceElement.innerHTML = rechargePriceElement.innerHTML + `<span style="text-decoration: line-through; margin-left: 8px; font-size: 17px; color: gray;">${formattedOriginalPrice2}</span>`;
      */
      
      const oneTimePurchaseLabel = document.querySelector('label.rc-radio.onetime-radio .rc-radio__label');  
      if (oneTimePurchaseLabel) {
        //oneTimePurchaseLabel.textContent = 'One-Time Purchase ' + formattedUpdatedPrice;
        oneTimePurchaseLabel.innerHTML = `One-Time Purchase — ${formattedUpdatedPrice} <span style="text-decoration: line-through; margin-left: 8px; font-size: 16px; color: #7F8080;">${formattedOriginalPrice2}</span>  
        <span class="pdp-widget__discount" style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; margin-left: 8px;border: 1px solid rgb(var(--border-color));">
      ${saleAmount}% OFF
    </span>`;
    /*
        if (oneTimePurchaseLabel.innerHTML.indexOf('—') < 0) {
          oneTimePurchaseLabel.innerHTML = oneTimePurchaseLabel.innerHTML.replace('One-Time Purchase', 'One-Time Purchase — ');
        }
    */
      }
      
      observerInstance.disconnect(); // Stop observing once the elements are found and updated
    }
  });

  // Start observing the body for any added nodes
  observer.observe(document.body, { childList: true, subtree: true });


  


}


//----------------
//RECHARGE PRICE MOD
//----------------
window.modRecharge = function() {
  const variantPriceElement = document.getElementById('VariantPrice-Sale');

  const variantPriceText = variantPriceElement.getAttribute('data-variant-price');
  const variantPrice = parseFloat(variantPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  const compareAtPriceText = variantPriceElement.getAttribute('data-compare-at-price');
  const compareAtPrice = parseFloat(compareAtPriceText.replace(/[^0-9.-]+/g, "")) || 0;

  const formattedPrice = formatMoney(variantPrice * 100);
  const formattedCompareAtPrice = formatMoney(compareAtPrice * 100).replace('.00', '');

  const rechargePrice = Math.round(variantPrice * 0.80 * 100) / 100;
  const formattedRechargePrice = formatMoney(rechargePrice * 100).replace('.00', '');

  // Observer for the dropdown (Wait for it to exist)
  const observerDropdown = new MutationObserver((mutations, observerInstance) => {
    let dropdown = document.querySelector('.rc-selling-plans-dropdown__select');

    if (dropdown) {
      //console.log("Dropdown found, updating selection...");

      let indexMap = {
        "10ml": 0,
        "60ml": 1,
        "120ml": 2,
        "500ml": 3,
        "Half Gallon": 2
      };

      if (variantTitle in indexMap) {
        dropdown.selectedIndex = indexMap[variantTitle];
        let event = new Event('change', { bubbles: true });
        dropdown.dispatchEvent(event);
        //console.log(`Dropdown updated to ${variantTitle}`);
      }

      observerInstance.disconnect(); // Stop observing after successful update
    }
  });

  observerDropdown.observe(document.body, { childList: true, subtree: true });

  // If saleAmount is 0, do not change prices
  if (saleAmount === 0) {
    //console.log("Sale amount is 0, only updating recharge price...");

    // Observer for .rc-radio__price (Wait for it to exist)
    const observerNormalSub = new MutationObserver((mutations, observerInstance) => {
      const rechargePriceElement2 = document.querySelector('.rc-radio__price');

      if (rechargePriceElement2) {
        rechargePriceElement2.innerHTML = ` ${formattedRechargePrice} 
          <span style="background-color: transparent; display: inline-block; margin-left: 8px;">
            <span style="padding:4px 8px;border: 1px solid rgb(var(--border-color));color: #FA1818;">SAVE 20%*</span>
          </span>`;

        //console.log("Updated recharge price successfully.");
        observerInstance.disconnect(); // Stop observing after successful update
      }
    });

    observerNormalSub.observe(document.body, { childList: true, subtree: true });

    return; // Exit the function early
  }
  
  // Use MutationObserver to update prices in the Recharge widget
  const observer = new MutationObserver(function(mutations, observerInstance) {
    const rechargePriceElement = document.querySelector('.rc-radio__price');
    if (rechargePriceElement) {
      rechargePriceElement.innerHTML = `${formattedRechargePrice}
      <span class="SUB-discount" style="background-color: transparent; display: inline-block; margin-left: 8px;">
            <span style="padding: 4px 8px;border: 1px solid rgb(var(--border-color));color: #FA1818;">40% OFF*</span>
          </span>`;
      
      const oneTimePurchaseLabel = document.querySelector('label.rc-radio.onetime-radio .rc-radio__label');  
      if (oneTimePurchaseLabel) {
        oneTimePurchaseLabel.innerHTML = `One-Time Purchase — ${formattedPrice} <span class="compare_price_sale" style="text-decoration: line-through; margin-left: 2px; color: #808181;">${formattedCompareAtPrice}</span>  
        <span class="OTP-discount" style="background-color: transparent; color: #FA1818; display: inline-block; padding: 4px 8px; border: 1px solid rgb(var(--border-color));">
      25% OFF
    </span>`;
      }
      observerInstance.disconnect(); // Stop observing once the elements are found and updated
    }
  });

  // Start observing the body for any added nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

const productMeta = document.getElementById('ProductMeta');
let saleAmount = parseInt(productMeta.getAttribute('data-sale-amount'), 10) || 0;

const salePriceDiv = document.querySelector('.price-list.price-list--product');
const originalPriceDiv = document.getElementById('original-price');

const variantTitleData = document.getElementById('VariantTitleData');
let variantTitle = variantTitleData.getAttribute('data-variant-title');
//console.log(variantTitle);

//document.addEventListener('DOMContentLoaded', updateSalePrice);
document.addEventListener('DOMContentLoaded', modRecharge);
document.addEventListener("change", function(e) {
  // Check if the changed input is a variant selector
  if (e.target.classList.contains('test')) {
    modRecharge();
  }
  
});






document.addEventListener("DOMContentLoaded", async function () {
  let targetVariantIds = ["42336746471526", "0987654321"]; // Replace with main product variant IDs
 
  console.log("ENTERED");


  console.log("🛒 Checking cart...");
    
            const response = await fetch(window.Shopify.routes.root + 'cart.js', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });
    
            const cart = await response.json();
            console.log("✅ Cart fetched successfully:", cart.items[1].id);

            
    let addOnVariants = [
        { id: "1111111111", title: "AromaCare Warranty - 1 Year" },
        { id: "2222222222", title: "AromaCare Warranty - 2 Years" },
        { id: "3333333333", title: "AromaCare Warranty - 3 Years" }
    ]; // Replace with actual add-on variant IDs & titles

    function addAddOnProduct(variantId) {
        console.log("Adding add-on variant to cart:", variantId);
        Rebuy.Cart.addLineItem({
            productId: variantId,
            quantity: 1,
        });
    }

    function removeAddOnProduct(variantId) {
        console.log("Removing add-on variant from cart:", variantId);
        let addOnItem = Rebuy.Cart.getLineItems().find(item => item.productId == variantId);
        if (addOnItem) {
            Rebuy.Cart.removeLineItem(addOnItem.id);
        }
    }

    function createCheckboxForProduct() {
        console.log("Checking for target variants in cart...");
        let cartItems = cart.items;

        cartItems.forEach((item) => {
            let variantId = item.id; // Adjust selector if needed
            console.log("Found variant in cart:", variantId);

            console.log(targetVariantIds)

            if (targetVariantIds[0] == variantId) {
                console.log("Target variant found, adding checkbox and dropdown...");

                let existingAddon = item.s(".addon-container");
                if (existingAddon) {
                    console.log("Add-on UI already exists, skipping...");
                    return;
                }

                let checkboxContainer = document.createElement("div");
                checkboxContainer.classList.add("addon-container");
                checkboxContainer.innerHTML = `
                    <label class="addon-checkbox">
                        <input type="checkbox" id="addonCheckbox-${variantId}"> Add AromaCare Warranty
                    </label>
                    <select id="addonDropdown-${variantId}" style="display: none;">
                        <option value="">Select a warranty option</option>
                        ${addOnVariants.map(variant => `<option value="${variant.id}">${variant.title}</option>`).join('')}
                    </select>
                `;

                let checkbox = checkboxContainer.querySelector(`#addonCheckbox-${variantId}`);
                let dropdown = checkboxContainer.querySelector(`#addonDropdown-${variantId}`);

                checkbox.addEventListener("change", function () {
                    if (this.checked) {
                        console.log("Checkbox checked, showing dropdown...");
                        dropdown.style.display = "block";
                    } else {
                        console.log("Checkbox unchecked, hiding dropdown and removing add-on...");
                        dropdown.style.display = "none";
                        removeAddOnProduct(dropdown.value);
                    }
                });

                dropdown.addEventListener("change", function () {
                    let selectedVariant = this.value;
                    if (selectedVariant) {
                        console.log("User selected add-on variant:", selectedVariant);
                        addAddOnProduct(selectedVariant);
                        checkboxContainer.remove(); // Remove UI after selection
                    }
                });

                item.appendChild(checkboxContainer);
            }
        });
    }

    createCheckboxForProduct();

    // Listen for cart updates
    document.addEventListener("rebuy:cart:updated", createCheckboxForProduct);
});
$(document).ready(function(){
  setTimeout( function () {
 if ($(".rc-template__radio").length > 0) {
  function updateSubPricing(type){
    var selected_type = type;
    var compareAt = $(".product-sticky-bar__info compare-at-price");
    if(selected_type == "subscription") {
       compareAt.addClass("hide-compare");
    }else{
      compareAt.removeClass("hide-compare");
    }
  }
   $(document).on('click', '.rc-template__radio .rc-radio', function (e) {
         updateSubPricing($(this).find('.rc-radio__input').val());
      })
       updateSubPricing ('subscription');
    }
  }, 1000);
})